export enum AnalyticTypeEnum {
    Revenue,
    AverageReceipt,
    ReceiptsQuantity,
    MobileApp,
    DiscrepancyIndex,
    QualityScores,
    TechnicalQualityScores,
    ComplaintIndex,
    GratitudeIndex,
    WriteOffCount,
    WriteOffActs,
    TagsRating,
}
